/**
 * Sprachumschalter.
 *
 * Wie beim Grundton eine Radiogruppe: Bei zwei gleichrangigen Möglichkeiten
 * muss sichtbar sein, welche gilt. Die Beschriftungen kommen aus den
 * Übersetzungen selbst — der Umschalter darf nicht die eine Stelle sein,
 * die stur deutsch bleibt.
 */
import { useTranslation } from 'react-i18next';
import { SPRACHEN, type Sprache } from '@/i18n';

export interface LanguageToggleProps {
  className?: string;
}

export function LanguageToggle({ className = '' }: LanguageToggleProps) {
  const { t, i18n } = useTranslation();
  const aktuell = i18n.resolvedLanguage ?? i18n.language;

  return (
    <div
      role="radiogroup"
      aria-label={t('language.label')}
      className={`inline-flex items-center gap-0.5 rounded-full bg-surface-200 p-0.5 ${className}`.trim()}
    >
      {SPRACHEN.map((sprache: Sprache) => {
        const aktiv = aktuell === sprache;
        return (
          <button
            key={sprache}
            type="button"
            role="radio"
            aria-checked={aktiv}
            aria-label={t(`language.${sprache}`)}
            title={t(`language.${sprache}`)}
            onClick={() => void i18n.changeLanguage(sprache)}
            className={[
              'rounded-full px-2 py-1 text-xs font-semibold uppercase transition-colors',
              aktiv
                ? 'bg-surface-100 text-surface-900 shadow-sm'
                : 'text-surface-500 hover:text-surface-700',
            ].join(' ')}
          >
            {sprache}
          </button>
        );
      })}
    </div>
  );
}

export default LanguageToggle;
